import React, { useRef, useState, useEffect } from "react"
import { css } from "@emotion/core"
import { extname } from "path"
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome"
import { faPause, faPlay } from "@fortawesome/free-solid-svg-icons"
import Hls from "hls.js"
import moment from "moment"

import Progress from "./progress"
import push from "../../utils/data-layer-media"

const baseStyles = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  line-height: 1rem;
  font-size: 1rem;

  .controls {
    display: block;
    padding: 0;
    padding-right: 0.5rem;
    button {
      cursor: pointer;
      user-select: none;
      border: 0;
      outline: 0;
      padding: 0;
    }
  }
  .progress {
    display: block;
    flex: 1 0 auto;
    cursor: pointer;
    height: 0.5rem;
    user-select: none;
  }
  .time {
    display: block;
    padding: 0;
    padding-left: 0.5rem;
    user-select: none;
  }

  /* Colors */
  .controls {
    button {
      background-color: transparent;
      /* iOS Safari は色を明示していない button をシステムアクセント色（青）で描く。
         アイコンは fill="currentColor" なので、指定しないと再生マークだけ青くなる。 */
      color: inherit;
    }
    button:hover,
    button:focus {
      color: var(--base02);
    }
  }
  .progress {
    background-color: var(--base3);
    border: 1px solid var(--base2);
    border-radius: 0.25rem;
    .value {
      background-color: var(--base03);
    }
    .value:hover,
    .value:focus {
      background-color: var(--base02);
    }
    .load {
      background-color: var(--base3);
    }
  }
`

function isM3u(src) {
  return extname(src) === ".m3u8" || extname(src) === ".m3u"
}

export default props => {
  const { className = "", preload = "metadata", src, state } = props
  const styles = props.css
  const audio = useRef(null)
  const progress = useRef(null)
  const [playing, setPlaying] = useState(false)
  const [duration, setDuration] = useState(0)
  const [time, setTime] = useState(0)
  useEffect(() => {
    switch (state) {
      case "play":
        play()
        break
    }
  }, [state])
  useEffect(() => {
    if (isM3u(src)) {
      if (audio.current.canPlayType("application/vnd.apple.mpegurl")) {
      } else if (Hls.isSupported()) {
        console.log("HLS supported")
        const hls = new Hls()
        hls.loadSource(src)
        hls.attachMedia(audio.current)
      } else {
      }
    }
  }, [src])

  const play = e => {
    audio.current.play()
  }
  const pause = e => {
    audio.current.pause()
  }
  const getTime = e => {
    const x = e.pageX - progress.current.offsetLeft // or e.offsetX (less support, though)
    return (x * duration) / progress.current.offsetWidth
  }
  const seek = e => {
    audio.current.currentTime = getTime(e)
  }
  const mouseMove = e => {
    progress.current.title = moment.unix(getTime(e)).format("m:ss")
  }

  return (
    <div className={[className, "player"].join(" ")} css={[baseStyles, styles]}>
      <audio
        src={src}
        preload={preload}
        ref={audio}
        onPlay={e => {
          setPlaying(true)
          push(e)
        }}
        onPause={e => setPlaying(false)}
        onEnded={e => {
          setPlaying(false)
          push(e)
        }}
        onTimeUpdate={e => {
          setTime(Math.round(e.target.currentTime))
          push(e)
        }}
        onDurationChange={e =>
          e.target.duration !== Infinity && setDuration(e.target.duration)
        }
      />
      <div class="controls">
        {playing ? (
          <button type="button" onClick={pause} title="pause">
            <Icon icon={faPause} />
          </button>
        ) : (
          <button type="button" onClick={play} title="play">
            <Icon icon={faPlay} />
          </button>
        )}
      </div>
      <Progress
        ref={progress}
        max={duration}
        value={time}
        onClick={seek}
        onMouseMove={mouseMove}
      />
      <div class="time">
        {moment.unix(time).format("m:ss")} /{" "}
        {duration ? moment.unix(duration).format("m:ss") : "--:--"}
      </div>
    </div>
  )
}
